<template>
  <div ref="docxFilePreview">
    <div v-if="errorMessage" class="bg-error" data-cy="">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { renderAsync } from 'docx-preview'; // Or 'docx-preview/dist/docx-preview.es'

export default {
  name: "DocxFilePreview",
  props: {
    url: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      fileContent: null,
      errorMessage: "",
    };
  },
  mounted() {
    this.getFileContent();
  },
  methods: {
    async getFileContent() {
      try {
        const response = await axios.get(this.url, { responseType: 'blob' });
        this.fileContent = response.data;
        this.errorMessage = ""; // Clear any previous error on success
        await renderAsync(this.fileContent, this.$refs.docxFilePreview);
      } catch (error) {
        console.error("Error fetching file content:", error);
        this.errorMessage = "Failed to load file content.";
        this.fileContent = null; // Ensure file is null on error
      }
    },
  }

}
</script>

<style>
.docx-wrapper {
  background: unset !important;
  padding: 0px !important;
}
</style>
